import { FC } from 'react';

import { Image, Span } from 'components/helpers';
import { getShortRelativeTime } from 'utils';
import { translations } from 'translations/en';
import './activity.scss';
import { IShopActivityProps } from 'types';
import { useRequireToken } from 'hooks/useRequireToken';

const Activity: FC<IShopActivityProps> = ({ image, date, text, id, repostId, onActivityClick }) => {
  const formattedDate = getShortRelativeTime(date);

  const postedText = repostId ? translations.SHOP.REPOSTED : translations.SHOP.POSTED;

  const dateText = `${postedText} ${formattedDate} ${translations.COMMON.AGO}`;

  const onClick = useRequireToken(() => onActivityClick(id));

  return (
    <div className="shop-activity" onClick={onClick}>
      <Span text={dateText} className="date" />
      <div className="content">
        {image && <Image withOverlay src={image} />}
        <Span text={text} className="text" />
      </div>
    </div>
  );
};

export default Activity;
